import { FC, memo } from 'react';
import NextImage from 'next/image';
import NextLink from 'next/link';

import {
  HousingProvider as UIHousingProvider,
  Name,
  Logo,
} from './housingProvider.styles';
import { ListingDetailsHousingProvider } from '@keaze/web/common/interfaces';
import { HousingProviderProps } from './housingProvider.types';

type RenderLogo = (
  housingProvider: ListingDetailsHousingProvider
) => JSX.Element;

const renderLogo: RenderLogo = ({ name, logoUrl, slug, featured }) => {
  const image = (
    <NextImage
      src={logoUrl}
      alt={name}
      width={120}
      height={100}
      objectFit="contain"
    />
  );

  if (featured) {
    return (
      <NextLink
        href={`/featured-housing-providers/${encodeURIComponent(slug)}`}
        prefetch={false}
        passHref
      >
        <a>{image}</a>
      </NextLink>
    );
  }

  return image;
};

export const HousingProvider: FC<HousingProviderProps> = memo(
  ({ housingProvider }) => {
    const { name } = housingProvider;

    return (
      <UIHousingProvider>
        <Logo container justifyContent="center" alignItems="center">
          {renderLogo(housingProvider)}
        </Logo>
        <Name variant="body2">{name}</Name>
      </UIHousingProvider>
    );
  }
);
